<template>
  <div>
    <PageAllow controller="Shops" action="shopStockOrdersInDetails" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("StockOrderIN.ObjectName")]) }}
              <v-chip
                v-if="stock_ins.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="stock_ins.status | stockOrderINStatusColor"
                :text-color="stock_ins.status | stockOrderINStatusTextColor"
                >{{ stock_ins.status | stockOrderINStatusText }}
              </v-chip>
              <v-spacer />
              <StockOrderInActions
                :stock_in="stock_ins"
                :shop_id="this.$route.query.shop_id"
                showExport
                :status="stock_ins.status"
              />
            </v-card-title>
          </v-expansion-panel-header>

          <ValidationObserver ref="observer">
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <!-- 出库单编号 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.stock_in_code") }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_ins.stock_order_code }}
                  </v-card>
                </v-col>
                <!-- 仓库名称 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.stock_name") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("StockOrderIN.Fields.default_stock_name") }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 创建时间 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.created_time") }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_ins.created | formatTime }}
                  </v-card>
                </v-col>
                <!-- 入库类型 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.stock_order_type") }}{{ $t("Global.colon") }}
                    </span>
                    <span>{{ stock_ins.in_type_str }}</span>
                  </v-card>
                </v-col>
                <!-- 仓库名称 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.creater") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                       {{ stock_ins.operater_name }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 供应商 -->
                <v-col cols="12" md="4" v-if="stock_ins.type == 11">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.supplier") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_ins.supplier_name }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 出库时间 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.finish_time") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_ins.type == 3 ? stock_ins.actual_finish_time : stock_ins.finish_time | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 实际发生时间 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.actual_time") }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherDatetime
                      class="my-n2"
                      v-if="editActualDateFlg"
                      v-model="stock_ins.actual_date"
                      type="datetime"
                      removeIcon
                      single-line
                      dense
                      hide-details
                    />
                    <span v-else>
                      {{ stock_ins.actual_date | formatTime }}
                    </span>
                    <!-- 修改实际发生时间 -->
                    <v-btn
                      v-if="!editActualDateFlg && (accountUser && accountUser.type == 1) && (stock_ins && stock_ins.type == 2)"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="editActualDateFlg = true"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("Order.actions.editExpectDate") }}
                    </v-btn>
                    <v-btn
                      v-if="editActualDateFlg"
                      small
                      dark
                      text
                      color="action"
                      class="mb-n2"
                      @click.stop="editActualDate()"
                    >
                      <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
                      {{ $t("CRUD.save") }}
                    </v-btn>
                  </v-card>
                </v-col>
                <!-- 调出门店名称 -->
                <v-col cols="12" md="4" v-if="stock_ins.type == 6">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.out_shop") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_ins.requisition_shop.shop_name }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 备注 -->
                <v-col cols="12" md="12">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.attachment") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_ins.memo }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 附件 -->
                <v-col cols="12" md="12" v-if="stock_ins.type == 2">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderIN.Fields.attachment_images")}}{{ $t("Global.colon") }}
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </ValidationObserver>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab @click.stop="tab = 0">
                {{ $t("ActivityFields.activities") }}
              </v-tab>
              <v-tab @click.stop="tab = 1" v-if="stock_ins.type == 2">
                {{ $t("StockOrderIN.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="stock_out_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="stock_ins.type == 2">
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="relations_orders"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        :headers="detailsHeaders"
        :items="stockInDetails"
        :search="filter"
        multi-sort
        class="elevation-2 px-4 mt-4"
        disable-pagination
        hide-default-footer
        :no-data-text="$t('StockOrderIN.DetailNoData')"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("StockOrderIN.ObjectName")]) }}
            </v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <span class="caption secondary--text pt-2">
              {{
                $t(
                  "$vuetify.dataFooter.pageText",
                  stockInDetails.length
                    ? [1, stockInDetails.length, stockInDetails.length]
                    : [0, 0, 0]
                )
              }}
            </span>
            <v-spacer />
            <v-row no-gutters class="me-n3">
              <v-spacer />
              <v-col cols="12" sm="9" md="8">
                <v-text-field
                  v-model="filter"
                  clearable
                  hide-details
                  :label="$t('Search.filter')"
                />
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-if="stockInDetails.length" v-slot:body.prepend>
          <tr no-gutters class="d-none d-sm-table-row">
            <td class="secondary--text">
              {{ $t("StockOrderIN.DetailFields.count_num") }}
            </td>
            <td></td>
            <td
              class="secondary--text"
              :colspan="isView && stock_ins.type == 2 ? '3' : '2'"
            ></td>
            <td class="align-end text-right">
              {{ count_num }}
            </td>
            <td></td>
            <td class="align-end text-right">
              {{ $t("Global.money") }}{{ count_price | formatMoney }}
            </td>
            <td :colspan="settings && settings.product_date_setting ? 3 : 1"></td>
            <td></td>
          </tr>
          <tr no-gutters class="d-table-row d-sm-none">
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header">
                {{ $t("StockOrderIN.DetailFields.stock_in_practical_num") }}
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ count_num }}
              </div>
            </td>
            <td class="v-data-table__mobile-row">
              <div class="v-data-table__mobile-row__header">
                {{ $t("StockOrderIN.DetailFields.total") }}
              </div>
              <div class="v-data-table__mobile-row__cell">
                {{ $t("Global.money") }}{{ count_price | formatMoney }}
              </div>
            </td>
            <td></td>
          </tr>
        </template>
        <template v-slot:header.order_num="{ header }">
          <span v-if="stock_ins.type == 11">
            {{ $t("StockOrderIN.DetailFields.stock_in_purchase_num") }}
          </span>
          <span v-else-if="stock_ins.type == 3">
            {{ $t("StockOrderIN.DetailFields.profit_num") }}
          </span>
          <span v-else-if="stock_ins.type == 6">
            {{ $t("StockOrderIN.DetailFields.requisitions_num") }}
          </span>
          <span v-else-if="isView">
            {{ $t("StockOrderIN.DetailFields.stock_in_practical_num") }}
          </span>
          <span v-else>
            {{ header.text }}
          </span>
        </template>
        <template v-slot:header.actions="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.Description="{ item }">
          <a
            class="text-no-wrap"
            :class="item.error_flg ? 'red--text' : ''"
            @click.stop="dialogMaterialID = item.material_id"
          >
            {{ item.Description }}
          </a>
        </template>
        <template v-slot:item.material_name="{ item }">
          <span>
            <span>
              {{ item.material_name }}
            </span>

            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              >
              {{ $t("StockOrderIN.DetailFields.standard") }}
              {{ $t("Global.colon") }}
              {{ item.standard_name }}
            </span>
          </span>
        </template>
        <template v-slot:item.unit="{ item }">
          <span>{{ item.unit }} </span>
        </template>
        <template v-slot:item.order_num="{ item }">
          <span>
            {{
              stock_ins.type == 11 && stock_ins.status == 2
                ? item.order_num
                : item.confirm_num
            }}
          </span>
        </template>
        <template v-slot:item.confirm_num="{ item }">
          <span>
            {{ item.confirm_num }}
          </span>
        </template>
        <template v-slot:header.price="{ header }">
          <span class="text-center text-no-wrap">
            {{ header.text }}
          </span>
        </template>
        <template v-slot:item.price="{ item }">
          <span>
            {{ $t("Global.money") }}
            {{ item.price | formatMoney }}
          </span>
        </template>
        <template v-slot:header.total="{ header }">
          <span class="text-center text-no-wrap">
            {{ header.text }}
          </span>
        </template>
        <template v-slot:item.total="{ item }">
          <!-- <span>
            {{ $t("Global.money") }}
            {{ (item.price * item.order_num) | formatMoney }}
          </span> -->
          <span>
            {{ $t("Global.money") }}
            {{ item.fee | formatMoney }}
          </span>
        </template>
        <template v-slot:item.production_date="{ item }">
          <span>{{ item.production_date | formatDate }}</span>
        </template>
        <template v-slot:item.expired_date="{ item }">
          <span>{{ item.expired_date | formatDate }}</span>
        </template>
        <template v-slot:item.memo="{ item }">
          <span>
            {{ item.memo }}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            v-if="item.new"
            small
            text
            class="danger--text pa-0"
            @click.stop="
              stock_in_details.splice(
                stock_in_details.findIndex((detail) => item.new == detail.new),
                1
              )
            "
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.qualify_report_img_url="{ item }">
          <!-- 质检报告 -->
          <v-btn
            v-if="(stock_ins && stock_ins.type == 2 && (item && (item.qualify_report_img_url && item.qualify_report_img_url.length)))"
            color="orange"
            style="color: white"
            class="my-1"
            small
            @click.stop="
              currentItem = item;
              qualifyReportDialog = true;
            "
          >
            {{ $t("StockOrderIN.DetailFields.qualify_report_img_url") }}
          </v-btn>
        </template>
      </v-data-table>
    </v-sheet>

  </div>
</template>
<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockOrderInActions from "./plugins/Actions";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import i18n from "@/i18n";
// import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";
import Shops from "@/api/shops";
import { mapState } from "vuex";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockOrderInActions,
    SearcherDatetime,
    ValidationObserver,
    // ValidationProvider,
  },
  data: () => ({
    tab: null,
    mode: "",
    stock_ins: { type: 11, price_type: null },
    stock_out_activities: [],
    relations_orders: [],
    panels: [0],
    filter: "",
    stock_in_details: [],
    addMaterial: null,
    addMaterials: [],
    stockType: null,
    initializeDialog: false,
    excelFile: null,
    stockDialog: false,
    Dialog: false,
    count_price: null,
    count_num: null,
    currentItem: null,
    qualifyReportDialog: false,
    editActualDateFlg: false,
  }),
  mounted() {
    this.getStockInsFromAPI()
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopPsi"),
          disabled: false,
          href: "/shop-psi",
        },
        {
          text: i18n.t("Nav.shopStockOrdersIn"),
          disabled: false,
          href: "/shop-stock-orders-in",
        },
        {
          text: i18n.t("Nav.stockInDetail"),
          disabled: true,
        },
      ];
      items.push({
        text: this.stock_ins && this.stock_ins.stock_order_code ? this.stock_ins.stock_order_code : "",
        disabled: false,
        accent: true,
      });
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("StockOrderIN.DetailFields.category"),
          align: "start",
          class: "text-no-wrap",
          value: "category_name",
        },
      ];
      headers.push({
        text: i18n.t("StockOrderIN.DetailFields.material_code"),
        align: "start",
        value: "material_code",
      });
      headers.push(
        {
          text: i18n.t("StockOrderIN.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("StockOrderIN.DetailFields.unit"),
          align: "start",
          value: "unit",
        }
      );

      if (this.stock_ins.type == 2) {
        headers.push({
          text: i18n.t("StockOrderIN.DetailFields.examines_num"),
          align: "end",
          value: "confirm_num",
        });
      }
      headers.push({
        text: i18n.t("StockOrderIN.DetailFields.order_num"),
        align: "end",
        value: "order_num",
      });
      headers.push(
        {
          text: i18n.t("StockOrderIN.DetailFields.stock_in_price"),
          align: "end",
          value: "price",
        },
        {
        text: i18n.t("StockOrderIN.DetailFields.total"),
        align: "end",
        sortable: false,
        value: "total",
      });
      if (this.settings && this.settings.product_date_setting == 1) {
        headers.push(
          {
            text: i18n.t("StockOrderIN.DetailFields.production_date"),
            align: "start",
            value: "production_date",
            width: 136,
          },
          {
            text: i18n.t("StockOrderIN.DetailFields.expired_date"),
            align: "start",
            value: "expired_date",
            width: 136,
          }
        );
      }
      headers.push({
        text: i18n.t("StockOrderIN.DetailFields.memo"),
        align: "start",
        sortable: false,
        width: "130px",
        value: "memo",
      });
      if (this.stock_ins.type == 2) {
        headers.push({
          text: i18n.t("StockOrderIN.DetailFields.qualify_report_img_url"),
          align: "start",
          value: "qualify_report_img_url",
        });
      }

      return headers;
    },
    stockInDetails() {
      return this.stock_in_details.map((detail) => {
        detail.Description = i18n.t("Material.materialNameWithCode", [
          detail.material_code,
          detail.material_name,
        ]);
        return detail;
      });
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    relationsHeaders: () => [
      {
        text: i18n.t("StockOrderIN.relationsFields.type"),
        align: "center",
        sortable: false,
        value: "type",
      },
      {
        text: i18n.t("StockOrderIN.relationsFields.code"),
        align: "center",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("StockOrderIN.relationsFields.created_time"),
        align: "center",
        sortable: false,
        value: "created",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },
  methods: {
    getStockInsFromAPI() {
      Shops.shopStockOrdersInDetails({
        stock_order_id: this.$route.params.id,
        shop_id: this.$route.query.shop_id,
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_ins = response.data.stock_in;
            this.stock_out_activities = response.data.order_activities;
            if (response.data.relations_orders) {
              this.relations_orders.push({
                type: "订单",
                code: response.data.relations_orders.order.order_code,
                created: response.data.relations_orders.order.created,
              });
              this.relations_orders.push({
                type: "验收单",
                code: response.data.relations_orders.examine.examine_code,
                created: response.data.relations_orders.examine.created,
              });
            }
            this.stock_ins.stock_order_details.forEach((detail) => {
              detail.fee = detail.fee
                ? detail.fee
                : this.stock_ins.status == 2
                ? detail.order_num * detail.price
                : detail.confirm_num * detail.price;
            });
          }
        }.bind(this)
      );
    },
    stockTakeOrdersExport() {
      // Shops.orderExport(this.stock_ins.id);
    },
    editActualDate() {
      if (!this.stock_ins.actual_date) {
        this.$snackbar.error(i18n.t("StockOrderIN.messages.editActualDateError"));
        return;
      }
      this.$store.dispatch("fullscreenLoading");
      Shops.updateActualDate({
        shop_id: this.$route.query.shop_id,
        id: this.$route.params.id,
        actual_date: this.stock_ins.actual_date
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.editActualDateFlg = false;
            this.$snackbar.success(i18n.t("StockOrderIN.messages.editActualDateSuccess"));
            this.getStockInsFromAPI();
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      ).catch(
        function () {
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },
  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/shop-stock-orders-in/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getStockInsFromAPI();
        }
      },
    },
    stock_ins: {
      deep: true,
      handler() {
        this.stock_in_details =
          this.stock_ins && this.stock_ins.stock_order_details
            ? this.stock_ins.stock_order_details
            : [];
        if (this.stock_ins.type) {
          this.stockType = this.stock_ins.type;
        }
      },
    },
    stock_in_details: {
      deep: true,
      handler() {
        var totalFee = 0;
        var countNum = 0;
        this.stock_in_details.forEach((item) => {
         if (
            this.stock_ins.price_type == 1 &&
            this.stock_ins.type == 11 &&
            this.isView
          ) {
            item.fee = item.price * item.confirm_num;
            countNum += item.confirm_num;
          } else if (
            this.stock_ins.price_type == 2 &&
            this.stock_ins.type == 11 &&
            this.isView
          ) {
            if (item.confirm_num) item.price = item.fee / item.confirm_num;
            countNum += item.confirm_num;
          } else {
            if (this.stock_ins.status == 3) {
              item.fee = item.price * item.confirm_num;
              countNum += item.confirm_num;
            } else {
              item.fee = item.price * item.order_num;
              countNum += item.order_num;
            }
          }
          totalFee += item.fee;
        });
        this.count_price = this.$numberFormatter.formatTwoDot(totalFee);
        this.count_num = this.$numberFormatter.formatTwoDot(countNum);
      },
    },
  },
};
</script>
